export const TYPEAHEAD_SEARCH_MIN_CHARS = 3;
export const TYPEAHEAD_SEARCH_RESULTS_LIMIT = 5;
export const SEARCH_RESULTS_MAX = 10000;